import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

export default function HourInput({
    size = 'small',
    variant = 'outlined',
    value,
    onChange,
    className,
    id,
    label,
    helperText = false,
    slotProps = {},
    sx,
}) {
    const [internalValue, setInternalValue] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (value && typeof value.format === 'function') {
            setInternalValue(value.format('HH:mm'));
        } else if (typeof value === 'string') {
            const trimmed = value.length > 5 ? value.slice(0, 5) : value;
            setInternalValue(trimmed);
        } else {
            setInternalValue('');
        }
    }, [value]);

    const handleChange = (event) => {
        let inputValue = event.target.value;
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/; // HH:mm (24h)

    if (inputValue.length > 5) {
        inputValue = inputValue.slice(0, 5);
    }

        setInternalValue(inputValue);
        setError(!regex.test(inputValue));

        if (onChange) {
            onChange({ target: { value: inputValue } });
        } 
    };

    return (
        <TextField
            size={size}
            variant={variant}
            value={internalValue}
            onChange={handleChange}
            className={className}
            id={id}
            label={label}
            helperText={error ? helperText : ""}
            error={error}
            inputProps={{
                pattern: '^([01]\\d|2[0-3]):([0-5]\\d)$',
                maxLength: 5,
            }}
            {...slotProps.field}
            sx={sx}
        />
    );
}